import React, { useState } from 'react';
import { Button, Loading } from 'ui';
import LoadingButton from 'ui/components/ButtonV2/LoadingButton';
import type { SyntheticEvent } from 'react';
interface CartButtonsProps {
  primaryButtonLabel: string;
  primaryButtonAction: () => void;
  showSecondaryButton?: boolean;
  secondaryButtonLabel?: string;
  secondaryButtonAction?: () => void;
  showKeepShoppingButton?: boolean;
  keepShoppingAction?: () => void;
  keepShoppingLabel?: string;
  showOnlyPrimaryButton?: boolean;
}
export function CartButtons({
  primaryButtonLabel,
  primaryButtonAction,
  showSecondaryButton = false,
  secondaryButtonLabel,
  secondaryButtonAction,
  showKeepShoppingButton = false,
  keepShoppingAction,
  keepShoppingLabel,
  showOnlyPrimaryButton = false
}: CartButtonsProps) {
  const [isPrimaryButtonLoading, setIsPrimaryButtonLoading] = useState(false);
  const [isSecondaryButtonLoading, setIsSecondaryButtonLoading] = useState(false);
  const clickHandler = async (event: SyntheticEvent, onClickAction?: () => void): Promise<void> => {
    event.stopPropagation();
    if (onClickAction) {
      await onClickAction();
    }
  };
  return <div className='flex flex-col gap-2.5' data-sentry-component="CartButtons" data-sentry-source-file="CartButtons.tsx">
      <LoadingButton data-testid='cart-continueButton' disabled={isPrimaryButtonLoading || isSecondaryButtonLoading} onClick={async event => {
      setIsPrimaryButtonLoading(true);
      await clickHandler(event, primaryButtonAction);
    }} size='medium' type='button' variant='secondary' data-sentry-element="LoadingButton" data-sentry-source-file="CartButtons.tsx">
        {isPrimaryButtonLoading ? <Loading className='absolute p-1 opacity-100' /> : null}
        {primaryButtonLabel}
      </LoadingButton>
      {!showOnlyPrimaryButton ? <>
          {showSecondaryButton && secondaryButtonLabel && secondaryButtonAction ? <LoadingButton data-testid='cart-secondaryContinueButton' disabled={isPrimaryButtonLoading || isSecondaryButtonLoading} onClick={async event => {
        setIsSecondaryButtonLoading(true);
        await clickHandler(event, secondaryButtonAction);
      }} size='medium' type='button' variant='primary'>
              {isSecondaryButtonLoading ? <Loading className='absolute p-1 opacity-100' /> : null}
              {secondaryButtonLabel}
            </LoadingButton> : null}
          {showKeepShoppingButton && keepShoppingAction && keepShoppingLabel ? <Button className='border-inactive border ' onClick={event => clickHandler(event, keepShoppingAction)} size='medium' variant='primary'>
              {keepShoppingLabel}
            </Button> : null}
        </> : null}
    </div>;
}